import React from 'react';
import { useTheme } from '../hooks/useTheme';

interface ThemeToggleProps {
  /** When true, renders an icon-only compact button (no label). */
  compact?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ compact = false }) => {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    if (theme === 'system') setTheme('light');
    else if (theme === 'light') setTheme('dark');
    else setTheme('system');
  };

  const icon =
    theme === 'light' ? (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ) : theme === 'dark' ? (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      </svg>
    ) : (
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    );

  const label = theme === 'light' ? 'Claro' : theme === 'dark' ? 'Oscuro' : 'Sistema';

  if (compact) {
    return (
      <button
        onClick={cycleTheme}
        className="flex items-center justify-center w-8 h-8 rounded-lg border border-border bg-transparent text-muted-foreground hover:bg-accent hover:text-foreground transition-colors"
        aria-label={`Cambiar tema (actual: ${label})`}
        title={`Tema: ${label}`}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      onClick={cycleTheme}
      className="relative inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-border bg-card text-card-foreground hover:bg-accent transition-colors"
      aria-label="Cambiar tema"
    >
      {React.cloneElement(icon, { className: 'w-5 h-5' })}
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
};
